import styled from 'styled-components'

import _Button from '~/components/button'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 8px;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Button = styled(_Button)`
  &&& {
    height: 50px;
    width: 40px;
    margin: 0;
    padding: 0 7px 0 7px;
    font-size: 14px;
    border: 1px solid ${({ theme }) => theme.color.border.input.default};
    background-color: ${({ theme }) => theme.color.background.input.default};

    &.decrement {
      border-right-width: 0;
    }

    &.increment {
      border-left-width: 0;
    }

    .amp-icon {
      text-align: center;
    }
  }
`

export const Input = styled.input`
  display: inline;
  text-align: center;
  box-sizing: border-box;
  font-size: 16px;
  height: 50px;
  width: 40px;
  margin: 0;
  color: ${({ theme }) => theme.color.text.default};
  border-color: ${({ theme }) => theme.color.border.input.default};
  border-width: 1px 0;
  background-color: ${({ theme }) => theme.color.background.input.default};

  appearance: none;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
    border: 2px solid ${({ theme }) => theme.color.border.input.focused};
  }
`
